module.exports = __webpack_public_path__ + "static/img/IMG_20150610_230350.e676ee56.jpg";